const apiUrl = 'https://bgwqmv5cm3.execute-api.us-east-2.amazonaws.com/prod' //portal-fanttech

export async function getDeviceMaps (username, deviceID) {
    // console.log("API = ", apiUrl + "/shapefiles?username=" + username + "&deviceID=" + deviceID)
    const resp = fetch(apiUrl + "/shapefiles?username=" + username + "&deviceID=" + deviceID)
    // console.log("resp = ", resp);
    return resp;
}

export async function getUserDevicesAPI (username) {
    const resp = fetch(apiUrl + "/devices?username=" + username);
    return resp;
}

export async function getDevicesFieldsAPI (deviceID) {
    const resp = fetch(apiUrl + "/campos?deviceID=" + deviceID);
    return resp;
}

export async function getFieldEventsAPI (campoID) {
    const resp = fetch(apiUrl + "/eventos?campoUUID=" + campoID);
    return resp;
}

export async function deleteEventAPI (campoID, eventoID, identityId) {
    const response = await fetch(`${apiUrl}/eventos/${eventoID}?campoUUID=${campoID}&identityId=${identityId}`, {
        method: "DELETE",
    });

    if (!response.ok) {
        throw new Error("Erro ao excluir evento");
    }
    // console.log("Na função deleteEventAPI diz que passou, eis a response ", response);
    return response;
}

export async function newShapefileAPIPost(username, shapefileUUID, deviceID, filename) {
    const novoShapefile = {
        username,
        shapefileUUID,
        deviceID,
        filename
    };

    console.log("Enviando shapefile:", novoShapefile);

    const response = await fetch(`${apiUrl}/shapefiles`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(novoShapefile)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("Erro na API:", errorText);
        throw new Error("Erro ao criar shapefile");
    }

    const data = await response.json();
    console.log("Resposta da API:", data);

    return data;
}

export async function deleteShapefileAPI (shapefileUUID, username, identityId) {
    const response = await fetch(`${apiUrl}/shapefiles/${shapefileUUID}?username=${username}&identityId=${identityId}`, {
        method: "DELETE",
    });

    if (!response.ok) {
        throw new Error("Erro ao excluir shapefiles");
    }
    console.log("Na função deleteShapefilesAPI diz que passou, eis a response ", response);
    return response;
}

export async function updateShapefilePermission(shapefileUUID, username, deviceID) {
    const response = await fetch(`${apiUrl}/shapefiles/${shapefileUUID}?username=${username}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            username,
            deviceID,
        })
    });
    if (!response.ok) {
        throw new Error("Erro ao atualizar shapefiles");
    }
    // console.log("Na função updateShapefilesPermission diz que passou, eis a response ", response);
    return response;
}

export async function getVehiclesAPI (deviceID) {
        const resp = fetch(apiUrl + "?deviceID=" + deviceID);
        return resp;
    }

